/**
 * Serialize the focused report row for "edit this" / "download this".
 * @param {object} context mounted page context
 * @return {object} public report context
 */
export function serializeReportsContext(context) {
	const route = String(context.route || '').toLowerCase();
	const onMaintenance = route === '/maintenance';
	const reportId = context.report_id ?? context.reportId;
	const reportName = context.report_name ?? context.reportName;
	const hasReport = onMaintenance &&
		typeof reportId === 'string' &&
		Boolean(reportId);
	return {
		report_id: hasReport ? reportId : null,
		report_name: hasReport && typeof reportName === 'string' && reportName
			? reportName
			: null,
	};
}
